import React from "react";
import errorimage from "../Assets/Images/404.webp";

const Notfound = () => {
  return (
    <>
      <section className="signin">
        <div className="container">
          <div className="centertext">
            <img src={errorimage} alt="404" className="notfoundimg" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Notfound;
